import readNumberEnv from './services/readNumberEnv';

const listContextCacheMaxEntries: number = Math.max(
  1,
  readNumberEnv(process.env.NEXT_PUBLIC_LIST_CONTEXT_CACHE_MAX_ENTRIES) ?? 100
);

export default listContextCacheMaxEntries;
